<template>
	<sf-data-table
		ref="dataTable"
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		selection
		paging
		:columns="getColumns_"
		:rows="resultList"
		fit="fit"
		:excel="isButton_(scrId, 'EX')"
		:customExcel="excelFunc"
		@changedPage="changedPage"
		@row-click="rowClick"
	>
		<template v-slot:actionsLeft>
			<!--  추가 -->
			<sf-button v-if="isButton_(scrId, 'CU')" line icon="square-plue" :onClick="addAction">
				{{ getMessage_('QWCC001488') }}
			</sf-button>
			<!-- 저장 -->
			<sf-button v-if="isButton_(scrId, 'CC') && showSaveBtn" line icon="file" :onClick="saveAction">
				{{ getMessage_('QWCC001131') }}
			</sf-button>
			<template v-if="searchParams.useYn !== 'N'">
				<!-- 미사용 -->
				<sf-button color="error" line v-if="isButton_(scrId, 'CR')" icon="trash" :onClick="() => toggleUseYnAction('N')">
					{{ getMessage_('QWCC001250') }}
				</sf-button>
			</template>
			<template v-else>
				<!-- 사용 -->
				<sf-button line v-if="isButton_(scrId, 'CR')" icon="sub-menu-off" :onClick="() => toggleUseYnAction('Y')">
					{{ getMessage_('QWCC002025') }}
				</sf-button>
			</template>
		</template>
		<template v-slot:actionsRight>
			<!-- 업로드(엑셀) -->
			<sf-button v-if="isButton_(scrId, 'EU')" line icon="excel" :onClick="openModal">
				{{ getMessage_('QWCC000927') }}
			</sf-button>
			<!-- 엑셀템플릿 다운 -->
			<sf-button v-if="isButton_(scrId, 'EU')" line icon="square-plue" :onClick="downExcelTemp">
				{{ getMessage_('QWCC001799') }}
			</sf-button>
		</template>
		<template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'fwdImg'">
				<template v-if="!!slotProps.row.fwdImgFileId">
					<span @click="() => onDownloadFile(slotProps.row.fwdImgFileId)" style="cursor: pointer">
						<i class="icon-sf-file"></i>
					</span>
				</template>
			</template>
		</template>
	</sf-data-table>
</template>

<script>
import _ from 'lodash';
import * as Yup from 'yup';
import { BASE_URL } from '@/constants';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import { SELECTED_ROW } from '../../store/state';

export default {
	props: { scrId: { type: String, default: '' } },

	methods: {
		...rootMethods,
		...serviceMethods,
		addAction() {
			if (this.isNew === false && this.hasChanged_) {
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001511'), //작성된 내용은 사라집니다. 계속 하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001969'), clickFn: this.initRowAction }] //진행할 경우
				});
			} else this.initRowAction();
		},
		initRowAction() {
			this.setState_({ key: 'oldSelectedRow', value: SELECTED_ROW() });
			this.setState_({ key: 'isNew', value: true });
			this.setRowInit_();
		},
		saveAction() {
			try {
				this.schemaSave.validateSync(this.selectedRow);
				if (this.sgrpList.length && !this.selectedRow.ckuSgrpCd) {
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001123')]));
				}
				if (this.selectedRow.creDataScnCd === 'Q' && !this.selectedRow.ipnWayCd) {
					// 배치에서 넘어온 정보가 아니고, 방식을 입력하지 않았을 때 에러
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001213')]));
				}
				if (Number(this.selectedRow.minVal) > Number(this.selectedRow.maxVal)) {
					throw new Error(this.getMessage_('QWCC001970')); //최소값(Min)은 최대값(Max)보다 클 수 없습니다.
				}
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001119'),
					buttons: [{ title: 'Ok', clickFn: this.save }]
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		async save() {
			try {
				this.$sf_toggleLoading(true);
				if (this.isNew) {
					this.setSelectedRow_({ key: 'lgrpCd', value: this.selectedRow.ckuLgrpCd });
					this.setSelectedRow_({ key: 'sgrpCd', value: this.selectedRow.ckuSgrpCd });
				}
				const {
					header: { code, messageCd },
					body
				} = await this.saveData_(this.selectedRowData_);
				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
					if (code === 0) {
						this.setState_({ key: 'selectedRow', value: body });
						this.refresh();
					}
				}
				if (code === 2) {
					// 중복건 발생
					this.$sf_showMessage({
						type: 'confirm',
						icon: 'confirm',
						message: this.getMessage_(messageCd), //중복건이 존재합니다. 계속진행하시겠습니까?
						buttons: [{ title: this.getMessage_('QWCC001969'), clickFn: () => this.getDupCase(body) }], //진행할 경우
						closeFn: () => {
							this.setSelectedRow_({ key: 'ckuLgrpCd', value: '' });
							this.setSelectedRow_({ key: 'ckuSgrpCd', value: '' });
						}
					});
				}
			} catch (error) {
				console.error(error);
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001402') }); //저장에 실패
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		//중복 건 동의 후 가져오기
		getDupCase(requestBody) {
			const { resultList } = requestBody;
			resultList && this.setState_({ key: 'selectedRow', value: resultList[0] });
			this.setState_({ key: 'isNew', value: false });
		},
		/** 저장 후 새로고침 */
		async refresh() {
			this.isLoaded = false;
			this.$sf_toggleLoading(true);
			try {
				await this.getList_();
				this.setRowInit_();
				this.setState_({ key: 'oldSelectedRow', value: SELECTED_ROW() });
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			} finally {
				this.$sf_toggleLoading(false);
				this.isLoaded = true;
			}
		},
		toggleUseYnAction(useYn) {
			try {
				const selected = this.$refs.dataTable.getSelectedRows();
				if (!selected.length) {
					throw new Error(this.getMessage_('MWCC000110')); // 선택된 행이 없습니다.
				}
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: useYn === 'N' ? this.getMessage_('MWCC000108') : this.getMessage_('QWCC002026'), // 삭제 : 사용으로 변경
					message: useYn === 'N' ? '' : this.getMessage_('QWCC002035'), //대분류, 소분류가 등록되어야만 사용으로 바꿀 수 있습니다.
					buttons: [
						{
							title: useYn === 'N' ? this.getMessage_('QWCC001136') : this.getMessage_('QWCC002025'),
							clickFn: () => this.toggleUseYn(selected, useYn)
						}
					] //삭제
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		async toggleUseYn(selected, useYn) {
			this.$sf_toggleLoading(true);
			try {
				const { header } = await this.toggleUseYnRows_({ rows: selected, useYn });
				this.$sf_toast({
					type: header.code === 0 ? 'ok' : 'error',
					message: this.getMessage_(header.messageCd)
				});
				header.code === 0 && this.refresh();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || error });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		resetSelection() {
			const checkedCount = document.getElementsByClassName('is-checked').length;
			for (let i = 0; i < checkedCount; i++) {
				document.getElementsByClassName('is-checked')[0].classList.remove('is-checked');
			}
			this.$emit('Refresh');
		},
		async rowClick(row) {
			if (this.isNew === false && this.hasChanged_) {
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001511'), //작성된 내용은 사라집니다. 계속 하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001969'), clickFn: () => this.rowChange(row) }] //진행할 경우
				});
			} else {
				this.rowChange(row);
			}
		},
		async rowChange(row) {
			this.setState_({ key: 'isNew', value: false });
			this.setState_({ key: 'selectedRow', value: { ...row } });
			this.setState_({ key: 'oldSelectedRow', value: { ...row } });
			this.selectedRow.ckuLgrpCd && (await this.getSgrpList_());
			//console.log('ckuLgrpCd', this.selectedRow.ckuLgrpCd);
			//console.log('sgrpList', this.sgrpList);
		},

		// 엑셀다운 템플릿
		async downExcelTemp() {
			this.$sf_toggleLoading(true);
			try {
				await this.excelTempDown_({ apiGubun: 'FWD_CKU' });
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || this.getMessage_('QWCC001920') }); //권한이 없거나 다운로드 할 수 없습니다.
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async onDownloadFile(fileId) {
			await this.fileDownload_({ fileId, fileSeq: '1' });
		},
		openModal() {
			// 엑셀업로드팝업 호출
			const param = {
				title: this.getMessage_('QWCC001816'), //타이틀바 값 [출하검사 항목정보 엑셀 업로드]
				apiGubun: 'FWD_CKU', //업무구분값
				flag: 'I' //INSERT는 i Update U로 만듬
			};
			//this.$refs.excelUploadPop.open(param); //ExcelUploadModal 팝업에 정의한 open팝업을 실행한다.
			this.$emit('PopupOpen', param); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
		},
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh');
		},
		excelFunc() {
			const queryStr = this.$sf_objectToQueryString({
				useYn: this.searchParams.useYn,
				lgrpCd: this.searchParams.lgrpCd?.join(','),
				sgrpCd: this.searchParams.sgrpCd?.join(',')
			});
			const url = `${BASE_URL}/pqy/fcku/fwdCku/v1/excels${queryStr}`;
			this.$sf_xlsxDown({ url, columns: this.getExcelColumns_ }).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		schemaSave() {
			return Yup.object().shape({
				ckuLgrpCd: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001122')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001122')])),
				// ipnWayCd: Yup.string()
				// 	.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001213')]))
				// 	.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001213')])),
				// icrtCd: Yup.string()
				// 	.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001243')]))
				// 	.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001243')])),
				useYn: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001163')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001163')])),
				ipnPrvsSbc: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001215')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001215')]))
			});
		},
		showSaveBtn() {
			if (this.isNew === '') return false;
			if (this.selectedRow?.lgrpCd === 'PHTG') return true;
			return this.hasChanged_;
		}
	}
};
</script>
